export const RESET_SHIPPING_ISFETCHING = 'RESET_SHIPPING_ISFETCHING';
export const LIST_SHIPPING_REQUEST = 'LIST_SHIPPING_REQUEST';
export const SHIPPING_LIST_REQUESTING = 'SHIPPING_LIST_REQUESTING';
export const LIST_SHIPPING_SUCCESS = 'LIST_SHIPPING_SUCCESS';
export const RESET_SHIPPING_QUERY = 'RESET_SHIPPING_QUERY';

export const LIST_SHIPPING_AVAILABILITY_REQUEST =
  'LIST_SHIPPING_AVAILABILITY_REQUEST';
export const SHIPPING_AVAILABILITY_LIST_REQUESTING =
  'SHIPPING_AVAILABILITY_LIST_REQUESTING';
export const LIST_SHIPPING_AVAILABILITY_SUCCESS =
  'LIST_SHIPPING_AVAILABILITY_SUCCESS';
